import { api } from '../lib/api';
import { mapActions } from 'vuex';
import { infiniteLoading } from '../lib/customEvents';

export default {
  data() {
    return {
      filters: {},
      estimations: {},
      rejectReason: {
        unusable_photo: 'unusable_photo',
        ordinary_money: 'ordinary_money',
        counterfeit_money: 'counterfeit_money',
        bullion_coin: 'bullion_coin',
      },
      totalEstimations: 0,
      expertComment: '',
      estimationValue: null,
    };
  },

  methods: {
    ...mapActions('app', ['setLoading', 'setFilters', 'setReferer']),

    fullView(id) {
      this.setReferer(this.$route);
      this.storeFilters();
      this.$router.push({
        name: 'estimation-full-view',
        params: { id },
      });
    },

    async fetchEstimations(filters = {}) {
      this.filters = filters;

      this.setLoading({ value: true, message: 'loading-estimations' });

      try {
        const response = await api.get(`api/estimations`, { params: filters });

        this.setLoading({ value: false });

        return response && response.data;
      } catch (e) {
        this.setLoading({ value: false });
      }
    },

    async filterEstimations({ sortKey, value } = {}) {
      // Reset the page when filtering/ordering
      delete this.filters.page;

      if (sortKey) Object.assign(this.filters, { [sortKey]: value });

      const estimationsCollection = await this.fetchEstimations(this.filters);

      if (!estimationsCollection || !estimationsCollection['hydra:member']) return;

      this.estimations = estimationsCollection['hydra:member'];

      this.totalEstimations = estimationsCollection['hydra:totalItems'];

      if (!estimationsCollection['hydra:totalItems']) return;

      this.$nextTick(() => document.dispatchEvent(infiniteLoading));
    },

    async expertFilterEstimations({ sortKey, value } = {}) {
      delete this.filters.expert;
      delete this.filters['exists[expert]'];

      await this.filterEstimations({ sortKey, value });
    },

    async paginateEstimations({ page, itemsPerPage }) {
      Object.assign(this.filters, { page, itemsPerPage });

      const estimationsCollection = await this.fetchEstimations(this.filters);

      if (!estimationsCollection || !estimationsCollection['hydra:member']) return;

      this.estimations.push(...estimationsCollection['hydra:member']);
    },

    async fetchEstimation(id) {
      try {
        const response = await api.get(`api/estimations/${id}`);

        return response && response.data;
      } catch (error) {}
    },

    async updateEstimation(cardUrl, params) {
      this.setLoading({ value: true, message: 'loading-estimation-update' });

      try {
        const response = await api.put(cardUrl, params);

        this.setLoading({ value: false });
        this.estimationValue = null;
        this.expertComment = '';
        return response && response.data;
      } catch (e) {
        this.setLoading({ value: false });
      }
    },

    async submitEstimation({ estimationValue = 0, estimation, expertComment }) {
      if (parseInt(estimationValue) < 1) {
        return { error: 'negative_value' };
      }

      const response = await this.updateEstimation(estimation['@id'], {
        estimationValue: parseInt(estimationValue),
        expertComment,
      });

      return response;
    },

    async updateAssignation(cardUrl, expert) {
      await this.updateEstimation(cardUrl, { expert });
    },

    storeFilters() {
      this.setFilters(this.filters);
    },

    eraseDateFilter() {
      delete this.filters['createdAt[after]'];
      delete this.filters['createdAt[before]'];
      this.beginDateFilter = '';
      this.endDateFilter = '';
    },

    eraseEstimatedExpertFilter() {
      delete this.filters['expert'];
    },
  },
};
